import { Dialog } from "@sportsmet/ui";
import type { ReactNode } from "react";
import { useState } from "react";

import { DEFAULT_REACTION_EMOJI } from "./reactionLogic";

export type typeReactionPickerDialogProps = {
  open: boolean;
  onSelect: (emoji: string) => void;
  onOpenChange: (open: boolean) => void;
};

export const ReactionPickerDialog = (
  props: typeReactionPickerDialogProps,
): ReactNode => {
  const [showMoreInput, setShowMoreInput] = useState(false);

  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title="React"
      autoFocus={false}
    >
      <div className="flex items-center gap-2">
        {DEFAULT_REACTION_EMOJI.map((emoji) => (
          <button
            key={emoji}
            type="button"
            onClick={() => {
              props.onSelect(emoji);
            }}
            className="min-h-touch-target min-w-touch-target text-h1"
          >
            {emoji}
          </button>
        ))}
        <button
          type="button"
          onClick={() => {
            setShowMoreInput(true);
          }}
          className="min-h-touch-target min-w-touch-target text-body"
        >
          More
        </button>
      </div>
      {showMoreInput ? (
        <div className="mt-2">
          <input
            maxLength={4}
            placeholder="Pick an emoji"
            autoFocus
            onChange={(e) => {
              const g = Array.from(e.target.value)[0];
              if (g) props.onSelect(g);
            }}
            className="rounded-md border border-hairline px-2 py-1 text-body"
          />
          <p className="text-caption text-ink-tertiary">
            Switch to your emoji keyboard to pick one.
          </p>
        </div>
      ) : null}
    </Dialog>
  );
};
